/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type RolesDetails_allPermissions$ref: FragmentReference;
declare export opaque type RolesDetails_allPermissions$fragmentType: RolesDetails_allPermissions$ref;
export type RolesDetails_allPermissions = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: RolesDetails_allPermissions$ref,
|};
export type RolesDetails_allPermissions$data = RolesDetails_allPermissions;
export type RolesDetails_allPermissions$key = {
  +$data?: RolesDetails_allPermissions$data,
  +$fragmentRefs: RolesDetails_allPermissions$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "RolesDetails_allPermissions",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6e7bc6e4cb2ea14fc6f10e7d652ed4d0';
module.exports = node;
